import { render, staticRenderFns } from "./MainContent.vue?vue&type=template&id=b337c32e&scoped=true"
import script from "./MainContent.vue?vue&type=script&lang=js"
export * from "./MainContent.vue?vue&type=script&lang=js"
import style0 from "./MainContent.vue?vue&type=style&index=0&id=b337c32e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b337c32e",
  null
  
)

export default component.exports